import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Success = () => {
  const navigate = useNavigate();

  useEffect(() => {
    alert('Payment was successful!');
    navigate('/');
  }, [navigate]);

  return null;
};

export default Success;
